<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="cro_coverage_task"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="taskCoverageForm"
          :redirect-detail="false"
          :show-add-button="true"
          :custom-button-detail="true"
          caption="<i class='fa fa-align-justify'></i> Pembagian Tugas CRO"
          addButton="Tambah Pembagian Tugas CRO"
          @editForm="editForm"
          @resetForm="resetForm"
          @refreshSchedule="refreshSchedule"
        ></global-table>
      </b-col>
    </b-row>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">{{label}} Pembagian Tugas CRO</h3>
      </div>

      <div v-if="loadingSubmit">
        <loading></loading>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="taskCoverageForm" validated novalidate>
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="employee_id" label="Karyawan">
                <model-select
                  id="employee_id"
                  :options="listEmployee"
                  v-model="$v.taskCoverageForm.employee_id.$model"
                  :isError="$v.taskCoverageForm.employee_id.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="taskCoverageForm.employee_id === null"
                  class="invalid-feedback-custom"
                >Group konsumen harus di isi.</div>
              </b-form-group>
            </b-col>
          <!-- 
            <b-col sm="3">
              <b-form-group label-for="related_gt" label="Cakupan Konsumen GT">
                <multi-select
                  :options="listCoverageGT"
                  :selected-options="item_related_gt"
                  placeholder="-- Harap pilih salah satu --"
                  v-model="$v.taskCoverageForm.related_gt.$model"
                  :isError="$v.taskCoverageForm.related_gt.$invalid"
                  @select="onSelectGT"
                ></multi-select>

              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="related_non_gt" label="Cakupan Konsumen Non GT">
                <multi-select
                  :options="listCoverageNonGT"
                  :selected-options="item_related_non_gt"
                  placeholder="-- Harap pilih salah satu --"
                  v-model="$v.taskCoverageForm.related_non_gt.$model"
                  :isError="$v.taskCoverageForm.related_non_gt.$invalid"
                  @select="onSelectNonGT"
                ></multi-select>

              </b-form-group>
            </b-col> -->

            <b-col sm="9">
              <b-form-group label-for="related_zone" label="Cakupan Zona">
                <multi-select
                  :options="listCoverageZone"
                  :selected-options="item_related_zone"
                  placeholder="-- Harap pilih salah satu --"
                  v-model="$v.taskCoverageForm.related_zone.$model"
                  :isError="$v.taskCoverageForm.related_zone.$invalid"
                  @select="onSelectZone"
                ></multi-select>
              </b-form-group>
            </b-col>

             <b-col sm="9">
              <b-form-group label-for="related_customer_group" label="Cakupan Customer Group">
                <multi-select
                  :options="listCustomerGroup"
                  :selected-options="item_related_customer_group"
                  placeholder="-- Harap pilih salah satu --"
                  v-model="$v.taskCoverageForm.related_customer_group.$model"
                  :isError="$v.taskCoverageForm.related_customer_group.$invalid"
                  @select="onSelectCustomerGroup"
                ></multi-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div slot="modal-footer" class="float-right">
        <div v-if="!loadingSubmit">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back
          </b-button>&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="submitAdd"
            :disabled="$v.taskCoverageForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "cro_task",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cro_coverage_task: [],
      listCoverageNonGT: [],
      listCoverageGT: [],
      listCoverageZone: [],
      listCustomerGroup: [],
      listEmployee: [],
      loading: true,
      loadingSubmit: false,
      isEdit: false,
       fields: [
        { key: "employee_name", label: "Nama Karyawan", sortable: true },
        { key: "total_customer_zone", label: "Handle Customer", sortable: true },
        { key: "customer_group_list", label: "Handle Customer Group", sortable: true },
        { key: "action", class: "text-center width-150" }
      ],
      /* fields: [
        { key: "employee_name", label: "Nama Karyawan", sortable: true },
        { key: "total_customer_gt", label: "Handle GT", sortable: true },
        { key: "total_customer_non_gt", label: "Handle Non GT", sortable: true },
        { key: "action", class: "text-center width-150" }
      ],*/
      taskCoverageForm: interfaces.cro_coverage_task,
      item_related_gt: [],
      item_related_zone: [],
      item_related_customer_group: [],
      item_related_non_gt: [],
      label: 'Tambah'
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations() {
    if(this.isEdit === false) {
      return custom_validation.task.add;
    }else {
      return custom_validation.task.edit;
    }
  },
  methods: {
    init: function() {
      this.isEdit = false;
      this.loading = true;
      this.getData();
      this.getDropdown();
    },
    getData: function() {
      this.axios
        .get("web/cro/all/")
        .then(response => {
          this.cro_coverage_task = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/task-cro/")
        .then(response => {
          this.listCoverageNonGT = response.data.coverage_non_gt;
          this.listCoverageGT = response.data.coverage_gt;
          this.listEmployee = response.data.employee;
          this.listCoverageZone = response.data.coverage_zone;
          this.listCustomerGroup = response.data.coverage_customer_group;

        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {});
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    editForm: function(editData) {
      this.label = 'Ubah';
      this.isEdit = true;
      this.item_related_gt = editData.recreate_related_gt;
      this.item_related_non_gt = editData.recreate_related_non_gt;
      this.item_related_zone = editData.recreate_related_zone;
      this.item_related_customer_group = editData.recreate_related_customer_group;
      this.taskCoverageForm = editData;
      this.taskCoverageForm.related_non_gt = editData.recreate_related_non_gt;
      this.taskCoverageForm.related_gt = editData.recreate_related_gt;
      this.taskCoverageForm.related_zone = editData.recreate_related_zone;
      this.taskCoverageForm.related_customer_group = editData.recreate_related_customer_group;   
   },
    resetForm: function() {
      this.label = 'Tambah';
      this.isEdit = false;
      this.resetItem();
      for (var a in interfaces.cro_coverage_task) {
        interfaces.cro_coverage_task[a] = null;
      }
      this.taskCoverageForm = interfaces.cro_coverage_task;
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin merubah pembagian tugas ini ?")) {
          this.loadingSubmit = true;
          this.axios
            .put("web/cro/update-task/", this.taskCoverageForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Pembagian",
                  message: response.data.message
                });
                this.cancelAdd();
                //this.$router.push({ path: "all/detail/" + response.data.id });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan pembagian tugas ini ?")) {
          this.loadingSubmit = true;
          this.axios
            .post("web/cro/add-task/", this.taskCoverageForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Pembagian",
                  message: response.data.message
                });
                this.cancelAdd();
                //this.$router.push({ path: "all/detail/" + response.data.id });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      }
      //console.log(this.taskCoverageForm)
    },

    refreshSchedule: function(row) {
      if (confirm("Apakah anda ingin meng-refresh list customer untuk CRO "+row.employee_name+" ?")) { 
           this.loading = true;
       //http://34.143.190.119/mbs-api/public/crawl/deliver_to_call_center/931/
        this.axios
            .get("crawl/deliver_to_call_center/"+row.employee_id+"/")
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Refresh Berhasil",
                  message: response.data.message
                });
                //this.$router.push({ path: "all/detail/" + response.data.id });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loading = false;
              this.init();
            });
      }
    },

    onSelectGT(items, lastSelectItem) {
      this.item_related_gt = items;
      this.taskCoverageForm.related_gt = items;
    },

    onSelectNonGT(items, lastSelectItem) {
      this.item_related_non_gt = items;
      this.taskCoverageForm.related_non_gt = items;
    },
    // deselect option
    resetItem() {
      this.item_related_gt = []; // reset
      this.item_related_non_gt = []; // reset
      this.item_related_zone= [];
      this.item_related_customer_group = [];
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    },
    onSelectZone(items, lastSelectItem) {
      this.item_related_zone = items;
      this.taskCoverageForm.related_zone = items;
    },
    onSelectCustomerGroup(items, lastSelectItem) {
      this.item_related_customer_group = items;
      this.taskCoverageForm.related_customer_group = items;
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
